import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ja from "./locales/ja.json";

export const resources = {
  ja: { translation: ja },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: "ja",
  fallbackLng: "ja",
  debug: import.meta.env.DEV,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  initImmediate: false,
});

export default i18n;
